export default __webpack_public_path__ + "static/media/R6No4.ec2091e5.mp3";